import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { UtilsService } from 'src/app/services/utils.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { MrsiService } from '../service/mrsi.service';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit, OnDestroy {
  public eventList:any[] = [{},{}]
  public scrollDistance = 1;
  public throttle = 10;
  public page = 1;
  public activeTab:string = "not_reviewed";
  public questionList: any = [];
  
  constructor(public mrsiService:MrsiService, 
    public sidePanelService:SidePanelService, 
    public notifier: NotifierService,
    private activatedRoute: ActivatedRoute,
    public utility:UtilsService){ 
    this.getEvents();
  }
  ngOnDestroy(): void {
    this.mrsiService.questionSearchText = "";
    this.activeTab = 'not_reviewed';
    this.mrsiService.tabType="pending";
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => { 
      this.mrsiService.event_id=params.id;
      this.mrsiService.getQuestions(1)
    });
  }

  switchTab(tabName:string){
    switch (tabName) {
      case "accept":
        this.activeTab = "accept";
        this.mrsiService.tabType="approved";
        this.mrsiService.getQuestions(this.page);
        break;
      case "reject":
        this.activeTab = "reject";
        this.mrsiService.tabType="rejected";
        this.mrsiService.getQuestions(this.page);
        break;
      default:
        this.activeTab = "not_reviewed";
        this.mrsiService.tabType="pending";
        this.mrsiService.getQuestions(this.page);
        break;
    }
  }

  refresh(){
    this.mrsiService.getQuestions(1,true);
    // this.getEvents();
    this.mrsiService.scrollToTop()
  }

  getEvents(){
      this.mrsiService.getEventsApi()
      .subscribe(res=>{
        if (res['status'] == 1) {
          this.mrsiService.mrsiEventList = res['result'];
          if(res['count']){
            this.sidePanelService.mrsiEventListOverallCountDetails = res['count'];
          }
          // console.log(this.mrsiService.mrsiEventList);
          this.sidePanelService.initSideDrawer('mrsi');
          if (!this.mrsiService.event_id) {
            let firstEventParent = Object.keys(this.mrsiService.mrsiEventList)[0];
            let eventObj = {parent:firstEventParent,selectedEvent:{}}
            let firstEvent = Object.keys(this.mrsiService.mrsiEventList[firstEventParent])[0]
            eventObj["selectedEvent"] = this.mrsiService.mrsiEventList[firstEventParent][firstEvent];
            this.mrsiService.selectEvent(eventObj);
          }
          this.setDefaultSidedrawer();
        }else{
          this.notifier.notify('error', 'Something went wrong');
        }
      })
  }

  onSearchChange(str){
    this.mrsiService.questionSearchText = str;
    if (str.length> 2) {
      this.mrsiService.getQuestions(1);
    }else if(str.length == 0){
      this.mrsiService.getQuestions(1);
    }
  }

  copyText(question, name, organization){
    let str = name;
    if (organization && organization != '') {
      str += " from "+organization
    } 
    str += " has question - "+question;
    this.utility.copyOnClick(str);
  }

  copyAllData(){
    let str = ""
    for (let i = 0; i < this.mrsiService.mrsiQuestionList.length; i++) {
      if (this.mrsiService.mrsiQuestionList[i]['text']) {
        str += this.mrsiService.mrsiQuestionList[i]['name'];
        if (this.mrsiService.mrsiQuestionList[i]['organization']) {
          str += " from "+this.mrsiService.mrsiQuestionList[i]['organization'];
        } 
        str += " has question - "+this.mrsiService.mrsiQuestionList[i]['text'] +"\n\n";
      }
      if (i == this.mrsiService.mrsiQuestionList.length -1) {
        this.utility.copyOnClick(str);
      }
    }
  }

  setDefaultSidedrawer(){
    let eventParentKeys = Object.keys(this.mrsiService.mrsiEventList);
    eventParentKeys.forEach((key,index) => {
      let eventParent = this.mrsiService.mrsiEventList[key];
      let subEventKeys = Object.keys(eventParent);
      subEventKeys.forEach((skey, i) =>{
        let subEvent = eventParent[skey];
        if (this.mrsiService.event_id == subEvent.id) {
          this.sidePanelService.navigateMenu("/mrsi/event-list",index);
          this.mrsiService.parentEventName = key;
          this.mrsiService.childEventName = subEvent.name;
        }
      })
    });
  }
  onScroll(){
    let page = <number> this.mrsiService.apiPageCount;
    this.mrsiService.getQuestions(page + 1)
  }

  getCount(type){
    if(Object.keys(this.mrsiService.questionCountDetails).length){
      switch(type){
        case 'not_reviewed':
          return this.mrsiService.questionCountDetails['pending'] ? this.mrsiService.questionCountDetails['pending'] : 0;
        case 'accept':
          return this.mrsiService.questionCountDetails['approved'] ? this.mrsiService.questionCountDetails['approved'] : 0;
        case 'reject':
          return this.mrsiService.questionCountDetails['rejected'] ? this.mrsiService.questionCountDetails['rejected'] : 0;
        default:
          return 0;  
      }
    }

  }
  
}
